// extracted by mini-css-extract-plugin
export default {"music_waves":"Payment_music_waves__RN-R4","waves":"Payment_waves__wxBVF"};